import { Suspense } from 'react';
import { Outlet } from 'react-router-dom';

import {
  useOpeningContext,
  useOpeningDetails,
} from '@/contexts/opening-context';

import { Analytics } from './analytics';
import { AutomationStatusBanner } from './automation-status-banner';
import { HiringGoalEmptyState } from './hiring-goal-empty-state';
import { ChannelsSection } from './channels-section';
import { GeneralRecommendation } from './general-recommendations';
import { PostingUnavailableBanner } from './posting-unavailable-banner';

function ChannelsContent() {
  const { metricsViewMode } = useOpeningContext();
  const { hiringGoal } = useOpeningDetails();

  const showHiringGoalEmptyState =
    metricsViewMode === 'hiring_goal' && !hiringGoal?.external_id;

  return (
    <>
      <PostingUnavailableBanner />
      {showHiringGoalEmptyState ? (
        <HiringGoalEmptyState />
      ) : (
        <>
          <AutomationStatusBanner />
          <Analytics />
          <GeneralRecommendation />
          <ChannelsSection />
        </>
      )}
      <Outlet />
    </>
  );
}

export function Channels() {
  return (
    <Suspense fallback={<Channels.Skeleton />}>
      <ChannelsContent />
    </Suspense>
  );
}

Channels.Skeleton = function ChannelsSkeleton() {
  return (
    <>
      <Analytics.Skeleton />
      <ChannelsSection.Skeleton />
    </>
  );
};
